<div class="not-found-container">
    <div class="mesh-background">
        <div class="mesh-orb orb-1"></div>
        <div class="mesh-orb orb-2"></div>
        <div class="mesh-orb orb-3"></div>
    </div>

    <div class="branding">
        <img src="assets/logos/logo-light.svg" alt="reGenesis" class="brand-logo" />
    </div>

    <div class="content">
        <div class="error-code">404</div>
        <h2 class="title" id="page-not-found-title">Product Not Found</h2>
        <p class="description">
            The product you scanned did not found in our system! Please ensure the QR code is clear and try again.
        </p>

        <a routerLink="/scanner" class="action-button">
            Scan Another Product
        </a>
    </div>

    <div class="absolute bottom-8 text-slate-500 text-xs uppercase tracking-widest opacity-50">
        Powered by esipick.com
    </div>
</div>